<div id="page-wrapper">
<app-navigation></app-navigation>
<router-outlet></router-outlet>
<app-footer></app-footer>
</div>